import styles from './button.module.css';

function Button({ className = '', children, onClick, title }) {
  return (
    <button className={`${className} ${styles.btnReset}`} onClick={onClick} title={title}>{children}</button>
  )
};

export default Button;